import type { ComponentProps } from 'react';

import { InfoAlternateIcon } from '../icons';
import { Tooltip } from './Tooltip';
import { IconButton } from './button/IconButton';

export function InfoTip({
	content,
	portal,
	position,
}: {
	content: string;
	portal?: ComponentProps<typeof Tooltip>['portal'];
	position?: ComponentProps<typeof Tooltip>['position'];
}) {
	return (
		<Tooltip content={content} portal={portal} position={position}>
			<IconButton icon={<InfoAlternateIcon />} onClick={() => {}} type="plain" small />
		</Tooltip>
	);
}
